/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import NodeCollectionEffectBase from './NodeCollectionEffectBase';

const {ccclass, property} = cc._decorator;

@ccclass
export default class SetAnimationSkinEffect extends NodeCollectionEffectBase
{
    @property
    protected skinName: string = '';

    protected trigger: () => void = () =>
    {
        this.reference.WithValue(nodeRef =>
        {
                nodeRef.Nodes.forEach(node =>
                {
                    const spine: sp.Skeleton = node.getComponent(sp.Skeleton);
                    if (!spine) { return; }

                    spine.defaultSkin = this.skinName;
                    spine.setSkin(this.skinName);
                });
        });
        this.complete();
    }
}
